import React from "react";
import PriceCard from "./PriceCard";
import { useHistory } from "react-router";
import { Alert } from "@mui/material";

const CartTotalCard = ({ cart, activeOffer }) => {
  const history = useHistory();
  const hasSoldOutItem = cart?.some((item) => (item.product_details?.qty_available ?? 0) <= 0);

  const calculateTotalPriceSum = (cartItems) => {
    if (!cartItems || cartItems.length === 0) {
      return 0;
    }
    // Use total_price from order_items — always authoritative (reset by backend on offer change)
    const totalPriceSum = cartItems.reduce((sum, item) => {
      return sum + (item.total_price || 0);
    }, 0);

    return ` ${totalPriceSum}`;
  };

  return (
    <section className="md:col-span-1 py-7 px-7 rounded-md shadow-sm bg-white/[0.7] flex flex-col gap-6 w-full h-min">
      {hasSoldOutItem && (
        <Alert severity="error" variant="outlined">
          Remove sold out item(s) to proceed to checkout.
        </Alert>
      )}
      <Alert severity="info" variant="outlined">
          Shipping charges are free for orders above ₹5000 or for items marked with Free Shipping.
      </Alert>

      {/* Active Offer Banner */}
      {activeOffer && (
        <div
          style={{
            background: activeOffer.is_discount_applied
              ? "linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)"
              : "linear-gradient(135deg, #fff3cd 0%, #ffeeba 100%)",
            border: `1.5px solid ${activeOffer.is_discount_applied ? "#28a745" : "#ffc107"}`,
            borderRadius: "10px",
            padding: "12px 14px",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "18px" }}>
              {activeOffer.is_discount_applied ? "🎉" : "🏷️"}
            </span>
            <span
              style={{
                fontWeight: "700",
                fontSize: "14px",
                color: activeOffer.is_discount_applied ? "#155724" : "#856404",
              }}
            >
              {activeOffer.is_discount_applied
                ? `${activeOffer.discount_percentage}% discount applied — ${activeOffer.sale_name}`
                : `${activeOffer.discount_percentage}% off in ${activeOffer.sale_name}`}
            </span>
          </div>
          {activeOffer.min_amount > 0 && (
            <p
              style={{
                fontSize: "12px",
                color: activeOffer.is_discount_applied ? "#155724" : "#856404",
                margin: "0",
                paddingLeft: "26px",
              }}
            >
              {activeOffer.is_discount_applied
                ? `Offer applied! You've qualified for ${activeOffer.discount_percentage}% off on your order.`
                : `This offer is valid on a minimum purchase of ₹${activeOffer.min_amount.toLocaleString("en-IN")}.`}
            </p>
          )}
        </div>
      )}

      <h1 className="text-xl">Price Details</h1>
      {cart?.map((product) => (
        <PriceCard key={product.id} product={product} />
      ))}

      <hr />
      <div className="flex justify-between items-center">
        <p className=" text-gray-600">Total</p>
        <p className="text-2xl">₹ {calculateTotalPriceSum(cart)}</p>
      </div>

      <div className="w-full py-2   flex flex-col gap-2">
        <button
          className="btn-rounded-primary rounded-full flex items-center justify-center gap-2 md:text-sm lg:text-base disabled:opacity-50 disabled:cursor-not-allowed w-full"
          disabled={hasSoldOutItem}
          onClick={() => {
            if (hasSoldOutItem) return;
            setTimeout(() => {
              history.push("/checkout", {
                state: "cart",
              });
            }, 100);
          }}
        >
          Proceed to Checkout
        </button>
      </div>
    </section>
  );
};

export default CartTotalCard;
